import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { isHubspotAuthenticatorErrorVisible } from '../../selectors/TwoFactorAuth';
import { loginVerificationWithHSAuthFailed, loginVerificationWithHSAuthResend } from 'LoginUI/lib/tracker';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PREFIX = 'login.twoFactor.errors';
const HubspotAuthenticatorError = ({
  restartTimer
}) => {
  const error = useSelector(isHubspotAuthenticatorErrorVisible);
  const [isResent, setIsResent] = useState(false);
  useEffect(() => {
    if (error) {
      setIsResent(false);
      loginVerificationWithHSAuthFailed();
    }
  }, [error]);
  if (!error && !isResent) {
    return null;
  }
  const i18nKey = `${PREFIX}.hubspotAppDenied`;
  const onResend = () => {
    if (restartTimer) {
      setIsResent(true);
      restartTimer();
      loginVerificationWithHSAuthResend();
    }
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isResent ? /*#__PURE__*/_jsxs(Alert, {
      use: "default",
      padding: "400",
      type: "success",
      "data-error-type": error,
      children: [/*#__PURE__*/_jsx(SuccessIcon, {
        size: "300",
        color: "border-accent-green-default"
      }), /*#__PURE__*/_jsx(Text, {
        margin: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${i18nKey}.resent`
        })
      })]
    }) : /*#__PURE__*/_jsx(Alert, {
      use: "default",
      padding: "400",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${i18nKey}.title`
      }),
      type: "danger",
      "data-error-type": error,
      children: /*#__PURE__*/_jsxs(TFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(Text, {
          marginBlock: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${i18nKey}.body`
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "link",
          onClick: onResend,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${i18nKey}.button`
          })
        })]
      })
    })
  });
};
export default HubspotAuthenticatorError;